import { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { onValue, ref, remove } from "firebase/database";
import VehicleCard from "./VehicleCards";
import styled from "styled-components";

const Container = styled.div`
  font-size: 16px;
  line-height: 1.6;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  margin-top: 40px;

  .poll {
    background: #f0f0f0;
    padding: 16px 20px;
    border-bottom: 1px solid #ddd;
    font-family: var(--font-semiBold);
    border-radius: 20px 20px 0 0;
    font-size: 24px;
  }

  .apolo {
    padding: 30px;

    p {
      font-size: 16px;
    }
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
`;

const Message = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  font-size: 24px;
  color: #555;
  padding: 60px 0;
`;

interface HomeProps {
  id?: string; // this is the id of the vehicle to exclude
}

const Home: React.FC<HomeProps> = ({ id }) => {
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const vehicleRef = ref(db, "vehicles");

    onValue(vehicleRef, (snapshot) => {
      const data = snapshot.val();
      let loadedVehicles: any[] = [];

      if (data) {
        loadedVehicles = Object.entries(data).map(([key, value]: [string, any]) => ({
          id: key,
          ...value,
        }));
      }

      // Filter out the vehicle with the same id
      const filtered = loadedVehicles.filter((vehicle) => vehicle.id !== id);
      setVehicles(filtered.slice(0, 3)); // Only show 3
      setLoading(false);
    });
  }, [id]);

  const handleDelete = (vehicleId: string) => {
    const vehicleRef = ref(db, `vehicles/${vehicleId}`);
    remove(vehicleRef)
      .then(() => setVehicles((prev) => prev.filter((v) => v.id !== vehicleId)))
      .catch((error) => console.error("Error deleting vehicle:", error));
    alert("Removed Successfully!");
  };

  return (
    <Container>
      <div className="poll">Similar Vehicles</div>
      <div className="apolo">
        {loading ? (
          <Message>Loading...</Message>
        ) : vehicles.length === 0 ? (
          <Message>No vehicles found.</Message>
        ) : (
          <Grid>
            {vehicles.map((vehicle) => (
              <VehicleCard key={vehicle.id} {...vehicle} onDelete={handleDelete} />
            ))}
          </Grid>
        )}
      </div>
    </Container>
  );
};

export default Home;
